import { render, staticRenderFns } from "./SharedOrder.vue?vue&type=template&id=c88a8b42&scoped=true"
import script from "./SharedOrder.vue?vue&type=script&lang=js"
export * from "./SharedOrder.vue?vue&type=script&lang=js"
import style0 from "./SharedOrder.vue?vue&type=style&index=0&id=c88a8b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88a8b42",
  null
  
)

export default component.exports